import React from 'react';
import Image from 'next/image';

const TrustSection = () => {
  return (
    <section className="section bg-primary text-white py-16">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Trusted Technology, Proven Over Decades</h2>
            <p className="text-lg mb-6">
            Personalia runs on the same enterprise-grade technology trusted by Fortune 500 companies and global print providers for over 20 years. Built on XMPie’s industry-leading platform for data-driven design automation, Personalia brings industrial-strength performance to modern creative teams.
            </p>
            <p className="mb-6">
            This isn’t a startup experiment. It’s a battle-tested foundation combined with the power of Adobe InDesign, scalable automation, and a clean, intuitive interface, so you can produce high-quality, personalized assets on demand without compromising design integrity.
            </p>

          </div>
          <div className="relative">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="relative h-24 w-full mb-6">
                <Image 
                  src="/images/XMPie-ACC-Logo-Color.png"
                  alt="XMPie Logo" 
                  fill
                  style={{objectFit: 'contain'}}
                  sizes="(max-width: 768px) 100vw, 50vw"
                />
              </div>
              <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <h3 className="font-bold text-gray-800 mb-2">Industry-Leading Technology</h3>
                <p className="text-gray-600">XMPie has been the trusted leader in InDesign-based personalization for more than two decades.</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="p-3 bg-gray-50 rounded-lg">
                  <div className="text-primary font-bold">uCreate</div>
                  <p className="text-sm text-gray-600">InDesign plugin for dynamic, data-powered templates.</p>
                </div>
                <div className="p-3 bg-gray-50 rounded-lg">
                  <div className="text-primary font-bold">uProduce</div>
                  <p className="text-sm text-gray-600">Powerful backend personalization engine</p>
                </div>
                <div className="p-3 bg-gray-50 rounded-lg">
                  <div className="text-primary font-bold">InDesign Server</div>
                  <p className="text-sm text-gray-600">Adobe's enterprise rendering technology</p>
                </div>
                <div className="p-3 bg-gray-50 rounded-lg">
                  <div className="text-primary font-bold">API-First</div>
                  <p className="text-sm text-gray-600">Modern interfaces for easy integration</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
